import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import {
  VendorRegistrationForm,
  VendorScoreForm,
} from "../../../app/models/user";
import UnAuthorizedLayout from "../../layout/unauth/UnAuthorizedLayout";
import FirstStep from "./steps/firststep/FirstStep";
import SecondStep from "./steps/secondstep/SecondStep";
import ThirdStep from "./steps/thirdstep/ThirdStep";
import FourthStep from "./steps/fourthstep/FourthStep";
import FifthStep from "./steps/fifthstep/FifthStep";
import ScorePage from "./steps/scorepage/ScorePage";
import PersonalInfo from "./steps/personalinfo/PersonalInfo";

const RegisterPage = () => {
  const [step, setStep] = useState(1);
  const [inputField, setInputField] = useState(new VendorRegistrationForm());
  const [scoreField, setScoreField] = useState(new VendorScoreForm());
  // Proceed to next step
  const nextStep = () => {
    return setStep(step + 1);
  };
  // Go back to prev step
  const prevStep = () => {
    return setStep(step - 1);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputField({ ...inputField, [e.target.name]: e.target.value });
  };

  const resetScoreField = () => {
    setScoreField(new VendorScoreForm());
  };
  // console.log(inputField)

  switch (step) {
    // case 0:
    //   return (
    //     <UnAuthorizedLayout>
    //       <FirstStep
    //         setStep={setStep}
    //         inputField={inputField}
    //         setInputField={setInputField}
    //         nextStep={nextStep}
    //       />
    //     </UnAuthorizedLayout>
    //   );
    case 1:
      return (
        <UnAuthorizedLayout>
          <SecondStep
            setStep={setStep}
            inputField={inputField}
            setInputField={setInputField}
            nextStep={nextStep}
          />
        </UnAuthorizedLayout>
      );
    case 2:
      return (
        <UnAuthorizedLayout>
          <ThirdStep
            setStep={setStep}
            scoreField={scoreField}
            setScoreField={setScoreField}
            nextStep={nextStep}
          />
        </UnAuthorizedLayout>
      );
    case 3:
      return (
        <UnAuthorizedLayout>
          <FourthStep
            setStep={setStep}
            scoreField={scoreField}
            setScoreField={setScoreField}
            nextStep={nextStep}
          />
        </UnAuthorizedLayout>
      );
    case 4:
      return (
        <UnAuthorizedLayout>
          <FifthStep
            setStep={setStep}
            scoreField={scoreField}
            setScoreField={setScoreField}
            nextStep={nextStep}
            resetScoreField={resetScoreField}
          />
        </UnAuthorizedLayout>
      );
    // case 5:
    //   return (
    //     <UnAuthorizedLayout>
    //       <ScorePage
    //         setStep={setStep}
    //         scoreField={scoreField}
    //         setScoreField={setScoreField}
    //         nextStep={nextStep}
    //       />
    //     </UnAuthorizedLayout>
    //   );
    case 5:
      return (
        <UnAuthorizedLayout>
          <PersonalInfo
            setStep={setStep}
            scoreField={scoreField}
            setScoreField={setScoreField}
            nextStep={nextStep}
            inputField={inputField}
            setInputField={setInputField}
            handleChange={handleChange}
          />
        </UnAuthorizedLayout>
      );
    default:
      return <RegisterPage />;
  }
};

export default observer(RegisterPage);
